/**
 * @generated SignedSource<<d4391b734baea4c914f9e60292024f8f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type project_nativeIssueTable_ProjectCell$data = {
  readonly project: {
    readonly avatar: {
      readonly large: string | null | undefined;
    } | null | undefined;
    readonly key: string;
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentType": "project_nativeIssueTable_ProjectCell";
};
export type project_nativeIssueTable_ProjectCell$key = {
  readonly " $data"?: project_nativeIssueTable_ProjectCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"project_nativeIssueTable_ProjectCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "project_nativeIssueTable_ProjectCell",
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "large"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraProjectField"
};

(node as any).hash = "c851920165e477cda5ca7d8297976e75";

export default node;
